module.exports = __webpack_public_path__ + "static/media/Moible_Data_FUNDAMENTOS_DE_DEVOPS.911dfa40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/fundamentos-devops/Moible_Data_FUNDAMENTOS_DE_DEVOPS.png
// module id = 90
// module chunks = 0